function escapeHtml(value) {
  return String(value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

function inline(text) {
  return escapeHtml(text).replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>');
}

function isTableRow(line) {
  return /^\s*\|.+\|\s*$/.test(line);
}

function isSeparator(line) {
  return /^\s*\|?(?:\s*:?-{3,}:?\s*\|)+\s*:?-{3,}:?\s*\|?\s*$/.test(line);
}

function splitCells(line) {
  return line.trim().replace(/^\|/, '').replace(/\|$/, '').split('|').map((cell) => cell.trim());
}

function isTableStart(lines, index) {
  return isTableRow(lines[index]) && index + 1 < lines.length && isSeparator(lines[index + 1]);
}

export function renderChatMarkdown(source) {
  const lines = String(source || '').replace(/\r\n/g, '\n').split('\n');
  const html = [];
  let index = 0;

  while (index < lines.length) {
    if (!isTableStart(lines, index)) {
      if (!lines[index].trim()) {
        index += 1;
        continue;
      }
      const paragraph = [];
      while (index < lines.length && lines[index].trim() && !isTableStart(lines, index)) {
        paragraph.push(lines[index]);
        index += 1;
      }
      html.push(`<p>${paragraph.map(inline).join('<br>')}</p>`);
      continue;
    }

    const header = splitCells(lines[index]);
    index += 2;
    const body = [];
    while (index < lines.length && isTableRow(lines[index])) {
      body.push(splitCells(lines[index]));
      index += 1;
    }
    html.push(
      `<table><thead><tr>${header.map((cell) => `<th>${inline(cell)}</th>`).join('')}</tr></thead>`
      + `<tbody>${body.map((row) => `<tr>${row.map((cell) => `<td>${inline(cell)}</td>`).join('')}</tr>`).join('')}</tbody></table>`,
    );
  }

  return html.join('');
}
